import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_MD, BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { FavoritesItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Download } from '../Download';
import { Expires } from '../Expires';
import { Favorite } from '../Favorite';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Publish } from '../Publish';
import { Favorites } from '../RowFor/Favorites';
import { Size } from '../Size';

const FavoritesItem = (props: FavoritesItemProps) => {
    const windowWidth = useWindowWidth();
    const {
        isFolder,
        onCheckboxClick,
        isSelected,
        thumbUrl,
        isVirus,
        ext,
        author,
        id,
        kind,
        storage,
        isAutoDelete,
        name,
        mtime,
        onFavorites,
        publicExpires,
        size,
        onDownload,
        onPublish,
        isPublic,
    } = props;

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Favorites {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic
                        isFolder={isFolder}
                        thumbUrl={thumbUrl}
                        isVirus={!!isVirus}
                        ext={ext || ''}
                        author={author}
                        id={id}
                        kind={kind}
                        isAutoDelete={isAutoDelete}
                    />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} id={id} />
                            <Favorite isAvailable isActive onClick={onFavorites} isActiveHidden={!isSelected} />
                            {isFolder ? <Expires expires={publicExpires} isAutoDelete={isAutoDelete} /> : <Date date={mtime} isWide />}
                            <Size size={size} />
                            <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                            <Publish onClick={onPublish} isActive={isPublic} />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName name={name} ext={ext || ''} id={id} />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} isWide />
                                    </span>
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared={!!publicExpires} />
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_MD && (
                                <Favorite isAvailable isActive onClick={onFavorites} isActiveHidden={!isSelected} />
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    {mtime && <Date date={mtime} isWide />}
                                    <Expires expires={publicExpires} isAutoDelete={isAutoDelete} isShared={!!publicExpires} />
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                {windowWidth <= BREAKPOINT_MD && (
                                    <Favorite isAvailable isActive onClick={onFavorites} isActiveHidden={!isSelected} />
                                )}
                                <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} />
                                <Publish onClick={onPublish} isActive={isPublic} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default FavoritesItem;
